import styles from "./main-app-menu.module.css";
import { usePaths } from "BEDROCK/paths";
import { MenuOption } from "./components";

interface ContentAdminProps {
  didClickOption: () => void;
}

export const ContentAdmin = (props: ContentAdminProps) => {
  const {
    templateListAdmin,
    collectionsAdmin,
    home,
    checkout,
    processOrder,
    navigateTo,
  } = usePaths();

  return (
    <div className={styles.adminContent}>
      <span className={styles.sectionTitle}>ADMIN</span>
      <MenuOption
        label="Home"
        icon="CHECK-UNCHECKED"
        onClick={() => {
          navigateTo(home);
          props.didClickOption();
        }}
      />
      <MenuOption
        label="Templates"
        icon="TEMPLATES"
        onClick={() => {
          navigateTo(templateListAdmin);
          props.didClickOption();
        }}
      />
      <MenuOption
        label="Collections"
        icon="COLLECTIONS"
        onClick={() => {
          navigateTo(collectionsAdmin);
          props.didClickOption();
        }}
      />
      <MenuOption
        label="Process Order"
        icon="CHECK-UNCHECKED"
        onClick={() => {
          navigateTo(processOrder);
          props.didClickOption();
        }}
      />
      <MenuOption
        label="Checkout"
        icon="CHECK-UNCHECKED"
        onClick={() => {
          navigateTo(checkout);
          props.didClickOption();
        }}
      />
    </div>
  );
};
